<template>
  <svg
    version="1.1"
    id="レイヤー_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    :width="`${size}px`"
    :height="`${size}px`"
    viewBox="0 0 24 24"
    style="enable-background: new 0 0 24 24"
    xml:space="preserve"
  >
    <g id="折れ線グラフ" transform="translate(-201.802 -391)">
      <path
        id="パス_343"
        class="st0"
        :style="{
          stroke: colors[0],
        }"
        d="M202.4,393.6v18.8h23.4"
      />
      <path
        id="パス_344"
        class="st1"
        :style="{
          stroke: colors[1],
        }"
        d="M207,406.8l5.1-7.2l5.5,3.3l5.9-7.6"
      />
      <circle
        id="楕円形_7"
        :style="{
          fill: colors[2],
        }"
        cx="206.9"
        cy="407"
        r="1.9"
      />
      <circle
        id="楕円形_8"
        :style="{
          fill: colors[2],
        }"
        cx="211.8"
        cy="399.2"
        r="1.9"
      />
      <circle
        id="楕円形_9"
        :style="{
          fill: colors[2],
        }"
        cx="217.6"
        cy="403.1"
        r="1.9"
      />
      <circle
        id="楕円形_10"
        :style="{
          fill: colors[2],
        }"
        cx="223.4"
        cy="395.4"
        r="1.9"
      />
    </g>
  </svg>
</template>
<script>
  export default {
    name: 'trendGraph',
    props: {
      size: {
        type: Number,
        default: 20,
      },
      colors: {
        type: Array,
        default: () => ['#6F6F6F', '#6F6F6F', '#6F6F6F'],
      },
    },
  };
</script>
<style scoped>
  .st0 {
    fill: none;
    stroke-width: 0.7238;
  }
  .st1 {
    fill: none;
    stroke-width: 0.965;
  }
</style>
